export default "__VITE_ASSET__WoCS_wMS__"